const ML = {
  ibanLength: 28,
};
export { ML };
